module.exports = __webpack_public_path__ + "static/media/grid-menu-loader.36ee399c.svg";